export default __webpack_public_path__ + "db5cead54f688e356a2e26fbcb883464.svg";